import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AbhollistenComponent } from './abhollisten/abhollisten.component';
import { AktuelleGruppenComponent } from './aktuelle-gruppen/aktuelle-gruppen.component';
import { GruppeDetailsComponent } from './gruppe-details/gruppe-details.component';
import { GruppenComponent } from './gruppen/gruppen.component';
import { HistorieGruppenComponent } from './historie-gruppen/historie-gruppen.component';
import { GlobaleTiersucheComponent } from './gruppen/globale-tiersuche/globale-tiersuche.component';
import { GruppenDashboardComponent } from './gruppen-dashboard/gruppen-dashboard/gruppen-dashboard.component';
import { HITMeldungenComponent } from './hitmeldungen/hitmeldungen.component';
import { GruppeSchweineDetailsComponent } from './schweine/gruppe-schweine-details/gruppe-schweine-details.component';
import { AnfrageDetailsComponent } from './schweine/anfrage-details/anfrage-details.component';
import { AktuelleGruppenSchweineComponent } from './schweine/aktuelle-gruppen-schweine/aktuelle-gruppen-schweine.component';
import { LandwirtOffeneAnfragenComponent } from './schweine/offene-anfragen/landwirt-offene-anfragen.component';
import { MenuTabGuard } from '../app.menu-tab.guard';

const routes: Routes = [
    {
        path: '',
        component: GruppenComponent,
        children: [
            {
                path: 'dashboard',
                component: GruppenDashboardComponent,
                canActivate: [MenuTabGuard],
                data: { menuTab: '/gruppen/dashboard', redirectTo: '/gruppen/aktuelle' },
            },
            { path: 'aktuelle', component: AktuelleGruppenComponent, title: 'Aktuelle Gruppe' },
            { path: 'aktuelle-schwein', component: AktuelleGruppenSchweineComponent, title: 'Schweine' },
            { path: 'aktuelle/:id', component: GruppeDetailsComponent, title: 'Gruppe-Details Rind' },
            {
                path: 'aktuelle/schwein/:id',
                component: GruppeSchweineDetailsComponent,
                title: 'Gruppe-Details Schwein',
            },
            { path: 'historie', component: HistorieGruppenComponent },
            { path: 'historie/:id', component: GruppeDetailsComponent },
            { path: 'historie/schwein/:id', component: GruppeSchweineDetailsComponent },
            { path: 'abhollisten', component: AbhollistenComponent },
            { path: 'globale-suche', component: GlobaleTiersucheComponent },
            { path: 'hitmeldungen', component: HITMeldungenComponent },
            {
                path: 'tierlisten',
                loadChildren: () => import('./tierlisten/tierlisten.module').then(m => m.TierlistenModule),
            },
            //schweine pages
            { path: 'schweine-gruppen/:id', component: GruppeSchweineDetailsComponent },
            { path: 'landwirt-anfrage-details/:id', component: AnfrageDetailsComponent },
            { path: 'schlachtanfragen', component: LandwirtOffeneAnfragenComponent },
            { path: '**', redirectTo: 'aktuelle' },
        ],
    },
];

@NgModule({ declarations: [], imports: [RouterModule.forChild(routes)], exports: [RouterModule] })
export class GruppenRoutingModule {}
